// Powers the swipe-through-images gallery on product cards
// (.product-item__scroll-track), so shoppers can flick through a
// product's photos without opening the product page.
//
// Deliberately uses the browser's native horizontal scroll + CSS
// scroll-snap instead of a JS carousel library: no library means no
// pixel-width calculations that can go wrong, and no dependency on any
// external script loading correctly.
//
// Runs on initial load AND watches the page for new cards being added
// later (infinite scroll, quick view, search results, "you may also
// like" carousels, the Fahhar Look tag page, etc.) via MutationObserver,
// so it never needs to be wired into any specific section's own JS.
(function () {
  function initTrack(track) {
    if (track.dataset.scrollReady) return;
    track.dataset.scrollReady = 'true';

    var scroller = track.closest('.product-item__scroller');
    var dotsContainer = scroller.querySelector('[data-scroll-dots]');
    var dots = dotsContainer ? Array.prototype.slice.call(dotsContainer.children) : [];
    var prevButton = scroller.querySelector('[data-scroll-prev]');
    var nextButton = scroller.querySelector('[data-scroll-next]');
    if (!dots.length) return;

    var ticking = false;

    function updateState() {
      var slideWidth = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / slideWidth);
      index = Math.max(0, Math.min(index, dots.length - 1));

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });

      if (prevButton) prevButton.disabled = index === 0;
      if (nextButton) nextButton.disabled = index === dots.length - 1;

      ticking = false;
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateState);
    });

    if (prevButton) {
      prevButton.addEventListener('click', function (evt) {
        evt.preventDefault();
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (evt) {
        evt.preventDefault();
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
    }

    updateState();
  }

  function scan(root) {
    var scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-scroll-track]').forEach(initTrack);
  }

  function start() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches('[data-scroll-track]')) {
            initTrack(node);
          }

          if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();